import { FetchApiProvider } from './fetch';
import { AdminActionsApi, CarriersApi, ClientsApi, Configuration as ClientsConfiguration, HelpTicketsApi, LocationsApi, MappersApi, ReportConfigsApi } from '@bluefalcon/clients-management-client-fetch';
import { UsersApi, IAMApi, Configuration as UsersConfiguration, TenantsApi, AuthApi, MembershipsApi, AdminApi } from '@bluefalcon/users-management-client-fetch';
import { environment } from '../utils/env.utils';

export const falconClients = {
    clients: new ClientsApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    carriers: new CarriersApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    mappers: new MappersApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    reportConfigs: new ReportConfigsApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    helpTickets: new HelpTicketsApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    states: new LocationsApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    adminActions: new AdminActionsApi(
        new ClientsConfiguration({
            basePath: environment.crmsBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    users: new UsersApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    tenants: new TenantsApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    iam: new IAMApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    auth: new AuthApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    memberships: new MembershipsApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
    admin: new AdminApi(
        new UsersConfiguration({
            basePath: environment.coreBaseUrl,
            fetchApi: FetchApiProvider,
        })),
};
